import { Events, pushEvent } from '@ff-os/shared-react/utils/analytics';
import { PhotoPrintsPdpThunk } from '@ff-scene-plugins/photo-prints-redux/store';
import { applyFirstMagicBorderIfFotofun } from '../helpers/applyFirstMagicBorderIfFotofun';
import { toGroupIfVariantExists } from '../helpers/toGroupIfVariantExists';
import { addGroup } from './addGroup';

export const createGroup = (paperId: string, sizeId: string, groupId: string, borderId?: string): PhotoPrintsPdpThunk => {

    return (dispatch, getState) => {

        const state = getState();
        const groupExists = state.project.groups.ids.includes(groupId);

        if (!groupExists) {
            const group = toGroupIfVariantExists(state, paperId, sizeId, groupId, borderId);
            if (group) {

                pushEvent(Events.CREATE_PHOTO_GROUP, {
                    variantId: group.variantId,
                    groupId: group.id,
                    paperId: paperId,
                    sizeId: sizeId,
                    borderId: borderId
                });

                dispatch(addGroup(group));

                // Automatically apply first magic border if variant contains "fotofun"
                dispatch(applyFirstMagicBorderIfFotofun(groupId, group.variantId));
            }
        }
    };
};